/* tslint:disable */

/**
 * Type of the client:
 *   * INDUSTRIAL
 */
type ClientType =
  'INDUSTRIAL';
namespace ClientType {
  export const INDUSTRIAL: ClientType = 'INDUSTRIAL';
  export function values(): ClientType[] {
    return [
      INDUSTRIAL
    ];
  }
}

export { ClientType }